import { Badge, Select } from "@chakra-ui/react";
import { TicketStatus } from "../types/ticket.types";
import i18n from "../i18n";
import { useTicket } from "../hooks/tickets.hooks";

const TicketStatusBadge = ({
  id,
  editable = false,
  onChange,
}: {
  id?: number;
  editable?: boolean;
  onChange?: (status: TicketStatus) => void;
}) => {
  const ticket = useTicket(id);

  if (!ticket) {
    return null;
  }
  const status = ticket.status;
  const ticketStatusBackgroundColors = new Map<TicketStatus, string>([
    [TicketStatus.NEW, "red.50"],
    [TicketStatus.OPEN, "brand.50"],
    [TicketStatus.BLOCKED, "purple.50"],
    [TicketStatus.CLOSED, "teal.50"],
  ]);
  const ticketStatusColors = new Map<TicketStatus, string>([
    [TicketStatus.NEW, "red.700"],
    [TicketStatus.OPEN, "brand.700"],
    [TicketStatus.BLOCKED, "purple.700"],
    [TicketStatus.CLOSED, "teal.700"],
  ]);
  const ticketStatusBorderColors = new Map<TicketStatus, string>([
    [TicketStatus.NEW, "red.300"],
    [TicketStatus.OPEN, "brand.300"],
    [TicketStatus.BLOCKED, "purple.300"],
    [TicketStatus.CLOSED, "teal.300"],
  ]);
  const handleChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(evt.target.value as TicketStatus);
    }
  };

  if (!editable) {
    return (
      <Badge
        h="1.5rem"
        w="fit-content"
        lineHeight="1.5rem"
        px="1rem"
        rounded="xl"
        backgroundColor={ticketStatusBackgroundColors.get(status) ?? "gray.50"}
        color={ticketStatusColors.get(status) ?? "gray.700"}
        border={"solid 1px"}
        borderColor={ticketStatusBorderColors.get(status) ?? "gray.300"}
        textTransform={"capitalize"}
        textAlign={"center"}
        isTruncated
      >
        {i18n.t(`ticket.status.${status}`)}
      </Badge>
    );
  }
  return (
    <Select
      h="1.5rem"
      lineHeight="1.5rem"
      rounded="xl"
      backgroundColor={ticketStatusBackgroundColors.get(status) ?? "gray.50"}
      color={ticketStatusColors.get(status) ?? "gray.700"}
      border={"solid 1px"}
      borderColor={ticketStatusBorderColors.get(status) ?? "gray.300"}
      textTransform={"capitalize"}
      w="fit-content"
      value={status}
      onChange={handleChange}
    >
      <option value="NEW">{i18n.t("ticket.status.NEW")}</option>
      <option value="OPEN">{i18n.t("ticket.status.OPEN")}</option>
      <option value="BLOCKED">{i18n.t("ticket.status.BLOCKED")}</option>
      <option value="CLOSED">{i18n.t("ticket.status.CLOSED")}</option>
    </Select>
  );
};

export default TicketStatusBadge;
